// Generated by scripts/update-seeq-icons.js from src/svg/seeq/folder.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcFolder = {
  prefix: 'fak',
  iconName: 'folder' as IconName,
  icon: [
    1321,
    1024,
    [],
    'f959',
    'M1297.3 381c-22.7-30.3-57.7-48.2-96.5-48.2h-51v-212.7c0-66.2-53.9-120.1-120.1-120.1h-296.9c-32.1 0-62.4 12.3-85.1 35l-72.8 72.8h-454.8c-32.1 0-62.4 12.3-85.1 35s-35 52.9-35 85.1v675.1c0 66.2 53.9 120.1 120.1 120.1h923.8c52 0 99.3-35 114.4-84.2l156-449.1v-2.9c11.3-36.9 4.7-75.6-18-105.9v0zM578.7 235.4c32.1 0 62.4-12.3 85.1-34.9l72.8-72.9h286.5v206.2h-727.2c-52 0-99.3 35-114.4 84.1l-53.9 155.1v-337.6h451.1zM1039.1 896.4h-889.7l151.3-435.9h889.7l-151.3 435.9z',
  ],
} satisfies IconDefinition;
